import { useRouter } from 'next/router'
import { useQueryClient } from 'react-query'

import { Text } from '@wartek-id/text-v1'
import { Shimmer } from '@wartek-id/shimmer'
import { useToast } from '@wartek-id/toast'

import {
  useAPIGetListPerencanaanPS,
  useAPISubmitApprovalApprove,
} from 'api/kinerja/tim-penilai-ps/perencanaan'
import { Header } from 'app/KinerjaShared/components/Header'
import TablePerencanaanPS from 'app/KinerjaTimPenilaiPSPage/components/TablePerencanaanPS'
import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'
import EmptyState from './EmptyState'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import { usePPSTrackEvent } from 'app/KinerjaPSPegawaiPage/hooks/usePPSTrackEvent'
import { queryKeys } from 'api/kinerja/tim-penilai-ps/config'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import AgreeButton from './AgreeButton'

export default function TimPenilaiDaftarPSSetujuiSekaligusPage() {
  const { basePath } = useBasePath()
  const router = useRouter()
  const toast = useToast()
  const { isPPKPengawasSekolah, isProfilePSPegawaiFetched } = useRoleContext()
  const { trackEventBase } = usePPSTrackEvent('-')
  const { period } = usePeriodContext()
  const queryClient = useQueryClient()

  const { data, isLoading, isFetched } = useAPIGetListPerencanaanPS({
    filter: 'DAPAT_DISETUJUI_SEKALIGUS',
    opts: {
      enabled: isProfilePSPegawaiFetched && isPPKPengawasSekolah,
    },
  })

  const { mutateAsync } = useAPISubmitApprovalApprove()

  const onConfirm = async () => {
    await mutateAsync({
      skpPsIds: data.data?.map((p) => p.skpPsId),
    })

    trackEventBase('perencanaan dinas', 'accept multiple perencanaan', {
      skp_id: JSON.stringify(data.data?.map((p) => p.skpPsId)),
    })
  }

  const onSuccess = () => {
    queryClient.invalidateQueries([
      queryKeys.API_GET_LIST_PERENCANAAN_PS,
      period.id,
      'DAPAT_DISETUJUI_SEKALIGUS',
    ])
    router.replace(`${basePath}/penilai/perencanaan/daftar-ps/disetujui`)
  }

  const onError = () => {
    toast({ message: 'Gagal setujui Perencanaan. Coba lagi.' })
  }

  return (
    <div className="px-24 py-6 m-auto max-w-7xl">
      <Header title="Daftar Perencanaan Kinerja" className="mt-6 mb-12" />
      <div className="flex flex-col items-center w-full bg-white border rounded-lg border-subdued">
        {isLoading && (
          <Shimmer height="100px" width="100%" data-testid="loading-list" />
        )}

        {isFetched && data?.data.length === 0 && <EmptyState />}

        {isFetched && data?.data.length > 0 && (
          <>
            <div className="w-full px-8 py-6 space-y-1">
              <div className="flex justify-between py-3 px-4 gap-4 w-full bg-surface-selected-default border border-interactive-default rounded-[4px]">
                <div className="flex flex-col gap-1">
                  <Text variant="heading-md" as="h2" color="informational">
                    {data?.data.length} Perencanaan dapat langsung Anda setujui
                    sekaligus
                  </Text>

                  <Text color="subdued">
                    Perencanaan sudah diperiksa oleh Tim Kinerja.
                  </Text>
                </div>
                <AgreeButton
                  perencanaan={data?.data ?? []}
                  onConfirm={onConfirm}
                  onSuccess={onSuccess}
                  onError={onError}
                />
              </div>
            </div>

            <TablePerencanaanPS
              basePath={basePath}
              isBulkApproval
              data={data?.data ?? []}
              isLoading={isLoading}
              className="!mt-0"
            />
          </>
        )}
      </div>
    </div>
  )
}
